import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { UserService } from '../services/user.service';
import * as XLSX from 'xlsx';

@Component({
    selector: 'app-clientassetreport',
    templateUrl: './clientassetreport.component.html',
    styleUrls: ['./clientassetreport.component.css']
})
export class ClientAssetReportComponent implements OnInit {
    displayedColumns: string[] = [];
    displayedColumnsVaultId = [
        'vaultId',
        'id',
        'name',
        'available',
        'balance',
        'total',
        'pending',
        'frozen',
        'lockedAmount',
        'blockHeight',
        'staked',
        'customerRefId',
    ];
    public dataSource: MatTableDataSource<any>;
    public dataSource2: MatTableDataSource<any>;
    public pageSize = 25;
    public pageSize2 = 25;
    public users: any[] = [];
    public currencies: any[] = [];
    public userSelected: any = [];
    userDropdownSettings: any = {};

    currencyDropdownSettings: any = {};
    currencyDropdownList: any = [];
    currencySelected: any = [];

    public pageSizeOptions2 = [5, 10, 25, 50, 100];
    public selectedWalletTypes: any = [{ id: 2, itemName: 'USER' }];
    public walletTypes: any = [
        { id: 1, itemName: 'CREDIT' },
        { id: 2, itemName: 'USER' },
    ];
    filter: any = {};
    vaultId: any;
   
    dropdownSettings: any = {};
    totalBalances: { [key: string]: number } = {};
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('paginator2', { read: MatPaginator }) paginator2: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('sort2', { read: MatSort }) sort2: MatSort;

    constructor(private userService: UserService) { }

    async ngOnInit() {
        await this.getUserForDropdown();
        await this.getCurrenciesForDropdown();
        this.filteredData();

        this.userDropdownSettings = {
            singleSelection: false,
            idField: 'id',
            textField: 'group',
            text: 'Select Users',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            badgeShowLimit: 1,
            enableSearchFilter: true,
            classes: 'myclass custom-class'
        };
        this.currencyDropdownSettings = {
            singleSelection: false,
            idField: 'id',
            textField: 'group',
            text: 'Currency',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            badgeShowLimit: 2,
            enableSearchFilter: true,            
            classes: 'myclass custom-class'
          };
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'id',
            textField: 'group',
            text: 'Select Groups',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 1,
            enableSearchFilter: true,
            classes: 'myclass custom-class'
        };
    }

    getUserForDropdown() {
        this.userService.getUserForDropdown().subscribe(users => {
            this.users = users.map(item => {
                return {
                    id: item._id,
                    itemName: item.name
                };
            });
        });
    }
    getCurrenciesForDropdown() {
        this.userService.getAllCurrency().subscribe(currency => {
            this.currencies = currency.map(item => {
                return {
                    id: item.CurrencyId,
                    itemName: item.CurrencySymbol
                };
            });
        });
    }
    
    applyFilterVaultId(value) {
        value = value.trim();
        value = value.toLowerCase();
        this.dataSource2.filter = value;
    }
    onDeSelect() {
        this.selectedWalletTypes = [];
        this.filteredData();
    }
    onCurrencySelectAll() {
        this.currencySelected = [];
        this.filteredData();
    }
    onUserDeSelect() {
        this.userSelected = [];
        this.filteredData();
    }
    onCurrencyDeSelect() {
        this.currencySelected = [];
        this.filteredData();
    }
    onSelect() {
        this.selectedWalletTypes
        this.filteredData();
    }
    onUserSelect() {
        this.userSelected
        this.filteredData();
    }
    onCurrencySelect() {
        this.currencySelected
        this.filteredData();
    }
    onDeSelectAll() {
        this.userSelected = [];
        this.filteredData();
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim().toLowerCase();
        this.dataSource.filter = filterValue;
    }
    exportArray() {
        const data = this.dataSource.data.map(row => {
            const rowData: any = {
                UserName: row.UserName,
                UserEmail: row.UserEmail,
                VaultId: row.VaultId,
            };
            this.displayedColumns.forEach(column => {
                if (column !== 'UserName' && column !== 'UserEmail' && column !== 'VaultId') {
                    rowData[column] = row[column];
                }
            });
            return rowData;
        });
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, 'client-asset-report.xlsx');
    }
    getVaultDetails(vaultId: any) {
        this.vaultId = vaultId;
        this.userService.getVault(vaultId).subscribe(data => {
            let vaultRes = data.assets.map(vault => {
                vault.vaultId = data.id;
                vault.customerRefId = data.customerRefId;
                vault.name = data.name;
                return vault;
            })
            if (vaultRes) {
                this.dataSource2 = new MatTableDataSource(vaultRes);
                this.dataSource2.paginator = this.paginator2;
                this.dataSource2.sort = this.sort2;
            }
        })
    }
    async filteredData() {
        this.updateFilter();
        try {
            const success = await this.userService.csrf().toPromise();
            this.filter['_csrf'] = success._csrf;
            this.userService.getClientAssetReport(this.filter).subscribe((reports: any[]) => {
                if (reports && reports.length > 0) {
                    const transformedData = [];
                    const totalBalances: any = {};
                    reports.forEach(report => {
                        const rowData: any = {
                            UserName: report.UserName,
                            UserEmail: report.UserEmail,
                            VaultId: report.VaultId
                        };
                        report.Currencies.forEach(currency => {
                            if (currency.AvailableBalance > 0) {
                                // Update total balance
                                if (!totalBalances[currency.Currency]) {
                                    totalBalances[currency.Currency] = 0;
                                }
                                totalBalances[currency.Currency] += currency.AvailableBalance;
                                rowData[currency.Currency] = currency.AvailableBalance;
                            }
                        });

                        transformedData.push(rowData);
                    });

                    const flatReports = transformedData.map(data => ({
                        UserName: data.UserName,
                        UserEmail: data.UserEmail,
                        VaultId: data.VaultId,
                        ...data
                    }));
                    const uniqueCurrencies: any[] = Array.from(new Set(flatReports.reduce((acc, data) => acc.concat(Object.keys(data)), []))).sort();

                    const coreColumns = ['UserName', 'UserEmail', 'VaultId'];
                    this.totalBalances = totalBalances;
                    this.displayedColumns = [...coreColumns, ...uniqueCurrencies.filter(column => !coreColumns.includes(column))];

                    this.dataSource = new MatTableDataSource([this.getTotalRow(), ...transformedData]);
                    this.dataSource.paginator = this.paginator
                    this.dataSource.sort = this.sort;
                } else {
                    this.dataSource = new MatTableDataSource([]);
                    this.dataSource.paginator = this.paginator
                    this.dataSource.sort = this.sort;
                }
            });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    getTotalRow() {
        const totalRow: any = {
            UserName: 'Total',
            UserEmail: '',
            VaultId: '',
        };
        // Calculate total balances for each currency
        this.displayedColumns.forEach(currency => {
            if (currency !== 'UserName' && currency !== 'UserEmail' && currency !== 'VaultId') {
                totalRow[currency] = this.totalBalances[currency] || 0;
            }
        });

        return totalRow;
    }
    updateFilter() {
        this.filter.userid = this.userSelected.map(user => user.id) || '';
        this.filter.currency = this.currencySelected.map(currency => currency.itemName);
        this.filter.walletTypes = this.selectedWalletTypes.map(types => types.itemName) || 'USER'
    }
}



// WEBPACK FOOTER //
// ./src/app/clientassetreport/clientassetreport.component.ts